export default __webpack_public_path__ + "static/media/Revenue_commerce_retail.ad376cf7.xlsx";